import { render, staticRenderFns } from "./ExpressInquiry.vue?vue&type=template&id=047916a0&scoped=true&"
import script from "./ExpressInquiry.vue?vue&type=script&lang=js&"
export * from "./ExpressInquiry.vue?vue&type=script&lang=js&"
import style0 from "./ExpressInquiry.vue?vue&type=style&index=0&id=047916a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047916a0",
  null
  
)

export default component.exports